import { useCallback } from 'react'

import { ProductV2 } from '@common'

import { useAppDispatch } from '@/utils/useAppDispatch'
import { useAppSelector } from '@/utils/useAppSelector'

import { useModalContext } from '../../contexts/ModalContext'
import { addProductThunk } from '../checkout/checkoutSlice'

export const useAddProduct = () => {
  const dispatch = useAppDispatch()
  const { openModal } = useModalContext()
  const market = useAppSelector((state) => state.config.market)
  const addProductHandler = useCallback(
    (product: ProductV2) => {
      const success = dispatch(addProductThunk(product))
      if (!success) {
        return false
      }
      return true
    },
    [dispatch],
  )

  if (market === null) {
    return () => {
      openModal({ type: 'UNAVAILABLE' })
      return false
    }
  }

  return addProductHandler
}
